import { useMutation } from "@apollo/client";

import createStripeAccountLink from "../mutation/createStripeAccountLink.graphql";

const useCreateStripeAccountLink = () => {
  return useMutation(createStripeAccountLink);
};

export default useCreateStripeAccountLink;
